<div class="h5-search">
  <div class="page-title">
    <span>{{ 'search' | translate }}</span>
    <i class="fi-x mutual-opacity onact96-not" (click)="close()"></i>
  </div>
  <ng-container *ngTemplateOutlet="searchMain"></ng-container>
</div>
<!-- 搜索主体 -->
<ng-template #searchMain>
  <div class="container">
    <app-scrollbar>
      <search-game-base
        [labelCodes]="labelCodes"
        [searchValue]="searchValue"
        [maxHeight]="'none'"
        (beforeClickItem)="close()"
      ></search-game-base>
    </app-scrollbar>
  </div>
</ng-template>
